var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 3.91667H12.5417M11.8125 3.91667L11.1803 12.7702C11.1541 13.1381 10.9895 13.4825 10.7196 13.7339C10.4496 13.9852 10.0945 14.125 9.72563 14.125H3.69104C3.32219 14.125 2.96703 13.9852 2.6971 13.7339C2.42718 13.4825 2.26254 13.1381 2.23635 12.7702L1.60417 3.91667H11.8125ZM5.25 6.83333V11.2083V6.83333ZM8.16667 6.83333V11.2083V6.83333ZM8.89583 3.91667V1.72917C8.89583 1.53578 8.81901 1.35031 8.68227 1.21357C8.54552 1.07682 8.36005 1 8.16667 1H5.25C5.05661 1 4.87115 1.07682 4.7344 1.21357C4.59766 1.35031 4.52083 1.53578 4.52083 1.72917V3.91667H8.89583Z",
    stroke: "#000000",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon--trash.961a94d625c711e37020d3c6349719e4.svg";
export { ForwardRef as ReactComponent };